// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__PmzAn","checkboxCol":"Table_checkboxCol__1-Dx-","emailCol":"Table_emailCol__3k5Uq","actionCol":"Table_actionCol__3xlPp"};